module.exports = __webpack_public_path__ + "media/images/cofinancing_entities/UE-FEDER-7ba9df115b5c0de9e9852668406f8d1e.png";